import React, { useEffect, useRef, useState } from "react";
import "./Galleries.scss";
import arrow from "../../assets/galleries/carousel/Chevron-chev.svg";
import angle from "../../assets/galleries/carousel/angle.svg";

function Gallery({ galleryContents, isTouchScreen }) {
  const length = galleryContents.length - 1;
  const [currentCenter, setCurrentCenter] = useState(0);
  const [currentLeft, setCurrentLeft] = useState(length);
  const [currentRight, setCurrentRight] = useState(1);
  const centerImg = useRef();
  const descCenter = useRef();
  const container = useRef();
  const swipe = useRef();

  const clickHandleArrow = (direction) => {
    if (direction === "left") {
      setCurrentRight(currentCenter);
      setCurrentCenter(currentLeft);
      setCurrentLeft(currentLeft === 0 ? length : currentLeft - 1);
    } else if (direction === "right") {
      setCurrentLeft(currentCenter);
      setCurrentCenter(currentRight);
      setCurrentRight(currentRight === length ? 0 : currentRight + 1);
    } else {
      setCurrentCenter(direction);
      setCurrentLeft(direction === 0 ? length : direction - 1);
      setCurrentRight(direction === length ? 0 : direction + 1);
    }
  };

  useEffect(() => {
    const gallery = container.current;
    const observer = new IntersectionObserver(
      function (entries) {
        if (entries[0]["isIntersecting"] === true) {
          if (entries[0]["intersectionRatio"] > 0.2) {
            gallery.style.opacity = "1";
          }
        }
      },
      { threshold: [0, 0.2] }
    );
    observer.observe(gallery);
    return () => {
      observer.unobserve(gallery);
    };
  }, []);
  const handleTouch = () => {
    if (swipe.current) {
      swipe.current.style.opacity = "0";
    }
  };

  return (
    <section
      className="gallery"
      ref={container}
      onTouchStart={handleTouch}
      onMouseDown={handleTouch}
    >
      <div className="gallery__content">
        <div className="gallery__content__imgs--desktop">
          <img
            src={arrow}
            className="arrow arrow--left"
            alt=""
            onClick={() => {
              clickHandleArrow("left");
            }}
          />

          <div className="gallery__content__imgs__img">
            <div className="gallery__content__imgs__img__container">
              <img
                alt=""
                src={galleryContents[currentCenter].img}
                className="img img--center"
                ref={centerImg}
              />
            </div>
            <div className="gallery__content__imgs__img__desc">
              <p className="caption gallery__caption" ref={descCenter}>
                {galleryContents[currentCenter].caption}
              </p>
            </div>
          </div>
          <img
            src={arrow}
            className="arrow arrow--right"
            alt=""
            onClick={() => {
              clickHandleArrow("right");
            }}
          />
        </div>
        <div className="gallery__content__imgs--mobile">
          {galleryContents.map((content, i) => {
            return (
              <div className="gallery__content__imgs__img" key={i}>
                <div className="gallery__content__imgs__img__container">
                  <img alt="" src={content.img} className="img img--center" />
                </div>
                <div className="gallery__content__imgs__img__desc">
                  <p className="caption gallery__caption">{content.caption}</p>
                </div>
              </div>
            );
          })}
        </div>
        {isTouchScreen ? (
          <p className="gallery__swipe" ref={swipe}>
            SWIPE
            <span>
              <img src={angle} alt="" className="angle" />
            </span>
          </p>
        ) : (
          <></>
        )}
      </div>
    </section>
  );
}

export default Gallery;
